<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,7C15,7,14,7,14,7C14,7,14,6,14,6C14,5.45,13.55,5,13,5C13,5,10,5,10,5C9.45,5,9,5.45,9,6C9,6,9,7,9,7C9,7,7,7,7,7C7,7,7,3,7,3C7,2.45,6.55,2,6,2C6,2,3,2,3,2C2.45,2,2,2.45,2,3C2,3,2,7,2,7C2,7,1,7,1,7C0.45,7,0,7.45,0,8C0,8.55,0.45,9,1,9C1,9,2,9,2,9C2,9,2,13,2,13C2,13.55,2.45,14,3,14C3,14,6,14,6,14C6.55,14,7,13.55,7,13C7,13,7,9,7,9C7,9,9,9,9,9C9,9,9,10,9,10C9,10.55,9.45,11,10,11C10,11,13,11,13,11C13.55,11,14,10.55,14,10C14,10,14,9,14,9C14,9,15,9,15,9C15.55,9,16,8.55,16,8C16,7.45,15.55,7,15,7C15,7,15,7,15,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AlignmentHorizontalCenter',
} as DefineComponent
</script>
